import React, { useState } from 'react'
import { useEffect } from 'react';
import { getDefaultName, userAvatar } from '../utils';
import { loadTalent, loadUserTalent } from '../utils/Network';

export default function ModalDegreeProgress({ degree_item , index}) {

    const [talent, setTalent] = useState(null);

    
    useEffect(() => {
       
    }, [])

    
    function BadgeClass(){
        
        if (degree_item.degree <3){
          
            return "badge bg-red mt-14";
        }
        else if (degree_item.degree  <6) {
            return "badge bg-yellow mt-14";
        }
        else if (degree_item.degree  < 8) {
            return "badge bg-light-blue mt-14";
        }
        else if (degree_item.degree  <=10) {
            return "badge bg-green mt-14";
        }

        
    }

    const ProgressClass=()=>{
        if (degree_item.degree  < 3) {

            return "progress-bar progress-bar-danger";
        }
        else if (degree_item.degree  < 6) {
            return "progress-bar progress-bar-yellow";
        }
        else if (degree_item.degree  < 8) {
            return "progress-bar progress-bar-primary";
        }
        else if (degree_item.degree  <= 10) {
            return "progress-bar  progress-bar-success";
        }
        
    }

    
    
    return (
        <tr key={degree_item.id} className={`ratingsrow`} >
            <td>
                <img src={userAvatar(degree_item.coursereferee.user.profile)} alt="" className=" img-circle width-20" />
            </td>
            <td style={{  paddingLeft:20 }}>
                <small title={`Weight: ` + degree_item.question.weight }>{getDefaultName(degree_item.question?.names)}</small>
                <div className="progress progress-xs progress-striped">
                    <div className={ProgressClass()} style={{ width: (degree_item.degree*10)+"%" }}></div>
                </div>
            </td>
            <td >
                <span className={BadgeClass()}>{degree_item.degree} </span>
            </td>
        </tr>
    )
}
